import React, {useContext} from 'react';
import { Input } from '@alifd/next';
import {ActivityContext} from '../../index';
import styles from '../../index.module.scss';


function ActivityName() {
  const { taskParams, setTaskParams, pageDisable } = useContext(ActivityContext);
  return (
    <div className={styles['cardBox']}>
      <div className={styles['titleBox']}>
        <span className={styles['redText']}>*</span>
        活动名称：
      </div>
      <Input
        maxLength={32}
        showLimitHint
        value={taskParams.taskName}
        disabled={pageDisable}
        style={{width:'288px'}}
        onChange={(v)=>{setTaskParams({...taskParams,taskName:v})}}
      />
    </div>
  );
}

export default ActivityName;
